$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.module').controller('ModuleCtrl', (function($rootScope, $scope, $stateParams, $state, moduleData, organizerChannel, ChannelAPI, ClassroomSettings) {
    $scope.moduleID = moduleData.id;
    $scope.title = moduleData.title;
    $scope.slug = moduleData.slug;
    $scope.intro = moduleData.intro;
    $scope.subtitle = moduleData.subtitle;
    $scope.startImage = moduleData.start;
    $scope.nextModule = moduleData.next_module;
    $scope.overview = moduleData.overview;
    $scope.useSmartphone = moduleData.smartphone;
    $scope.downloads = moduleData.downloads;
    $scope.links = moduleData.links;
    $scope.api = ChannelAPI.set(organizerChannel);
    $scope.api.pushMessageScreen(false, '', 'Je bent verbonden. Hoera!', 'thumbs-up');
    $scope.isInteractive = ClassroomSettings.get().interactive;
    $scope.baseurl = (typeof localized !== 'undefined' ? localized.assets : '');
    $scope.homeurl = (typeof localized !== 'undefined' ? localized.url : '');
    $scope.voteurl = (moduleData.voteurl !== false ? moduleData.voteurl.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '') : '');
    $scope.settings = {};
    $scope.settings.options = moduleData.answers;
    $rootScope.page.setTitle($scope.title);
    $scope.start = (function() {
      var firstChapter = moduleData.chapters[0].id;
      $stateParams.chapter = firstChapter;
      $stateParams.slide = 1;
      $state.go('module.chapter.slide', $stateParams, {reload: true});
    });
    $scope.toggleFullScreen = function() {
      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    };
  })).controller('ChapterCtrl', (function($rootScope, $scope, $stateParams, $state, moduleData) {
    $scope.chapter = _.find(moduleData.chapters, {id: $stateParams.chapter});
    var chapter_index = _.findIndex(moduleData.chapters, {id: $stateParams.chapter});
    $rootScope.page.setTitle($scope.chapter.title);
    $scope.chapter.slug = moduleData.slug;
    $scope.nextChapter = false;
    $scope.prevChapter = false;
    if (chapter_index + 1 < moduleData.chapters.length) {
      var nextChapter = moduleData.chapters[chapter_index + 1];
      $scope.nextChapterId = nextChapter.id;
    }
    if (chapter_index > 0) {
      var prevChapter = moduleData.chapters[chapter_index - 1];
      $scope.prevChapterId = prevChapter.id;
      $scope.prevChapterLast = prevChapter.slides.length;
    }
  })).controller('SlideCtrl', (function($rootScope, $scope, $localStorage, $stateParams, $state, $sce, $timeout, AudioManager, ClassroomSettings, moduleData, VoiceOver) {
    $scope.baseurl = (typeof localized !== 'undefined' ? localized.assets : '');
    $scope.homeurl = (typeof localized !== 'undefined' ? localized.url : '');
    $scope.overview = moduleData.overview;
    $scope.moduleImage = moduleData.image;
    $scope.worlds = moduleData.worlds;
    $scope.slideID = parseInt($stateParams.slide);
    $scope.slide = $scope.chapter.slides[$scope.slideID - 1];
    $scope.$storage = $localStorage.$default({
      finished: [],
      finishedTemp: []
    });
    var slug = moduleData.worldslug;
    $scope.moduleFinished = (function() {
      if (!$scope.$storage.finished.some((function(e) {
        return e === slug;
      }))) {
        $scope.$storage.finishedTemp.push(slug);
      }
    });
    if ($scope.slide.type == "worlds") {
      $timeout(function() {
        $scope.$storage.finished = $scope.$storage.finishedTemp;
      }, 1000);
    }
    $scope.resetWorlds = (function() {
      delete $scope.$storage.finished;
      delete $scope.$storage.finishedTemp;
    });
    $scope.worldsFinished = (function() {
      if ((typeof $scope.$storage.finished !== 'undefined') && ($scope.$storage.finished.length == $scope.worlds.length)) {
        return true;
      } else {
        return false;
      }
    });
    $scope.chapterPagination = $scope.chapter.title + ' ' + ($scope.chapter.slides.length > 1 ? '(' + $scope.slideID + '/' + $scope.chapter.slides.length + ')' : '');
    $rootScope.page.setTitle($scope.chapterPagination);
    $scope.slideObj = {};
    $scope.slideObj.stage = "initial";
    $scope.api.pushMessageScreen(false, $scope.chapterPagination, "Alle ogen naar voren", "wait");
    if ($scope.slideID === $scope.chapter.slides.length && !$scope.nextChapterId) {
      $scope.lastSlide = true;
    }
    if ($scope.slideID === 1 && !$scope.prevChapterId && !$scope.startImage) {
      $scope.firstSlide = true;
    }
    $scope.trustSrc = (function(src) {
      return $sce.trustAsResourceUrl(src);
    });
    VoiceOver.stop();
    if ($scope.slide.voice_over) {
      VoiceOver.play($scope.slide.voice_over, function() {
        $rootScope.$broadcast('state', {state: 'done'});
      });
    }
    $scope.next = (function() {
      if ($scope.slideID < $scope.chapter.slides.length) {
        $stateParams.slide = $scope.slideID + 1;
        $state.go('module.chapter.slide', $stateParams, {reload: true});
      } else {
        if ($scope.nextChapterId) {
          $stateParams.chapter = $scope.nextChapterId;
          $stateParams.slide = 1;
          $state.go('module.chapter.slide', $stateParams, {reload: true});
        }
      }
    });
    $scope.prev = (function() {
      if ($scope.slideID > 1) {
        $stateParams.slide = $scope.slideID - 1;
        $state.go('module.chapter.slide', $stateParams, {reload: true});
      } else {
        if ($scope.prevChapterId) {
          $stateParams.chapter = $scope.prevChapterId;
          $stateParams.slide = $scope.prevChapterLast;
          $state.go('module.chapter.slide', $stateParams, {reload: true});
        } else {
          $state.go('module.start', $stateParams, {reload: true});
        }
      }
    });
    $scope.truePercentage = (function(percentage) {
      var clean_percentage = parseFloat(percentage).toFixed(2);
      return (clean_percentage * 100) + '%';
    });
    $scope.toggleFullScreen = function() {
      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    };
  }));
  return {};
});

